import { Box, styled, Typography } from '@mui/material';
import { palette } from 'view/themes/palette';

export const EditContainer = styled(Box)<{ marginBottom: string }>(({ marginBottom }) => {
  return {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '32px',
    marginBottom,
  };
}) as typeof Box;

export const EditContainerBlock = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
}) as typeof Box;

export const EditContainerLabel = styled(Typography)({
  color: palette.text.header_unknown,
  fontSize: '16px',
  fontWeight: 600,
  lineHeight: '128%',
}) as typeof Typography;

export const EditContainerValue = styled(Typography)({
  color: palette.text.value_unknown,
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '136%',
}) as typeof Typography;

export const EditContainerEditButton = styled(Typography)<{ disabled?: boolean }>(({
  disabled,
}) => {
  return {
    display: 'flex',
    color: disabled ? palette.unknown.disabled_grey : palette.primary.purple500,
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '128%',
    cursor: disabled ? 'not-allowed' : 'pointer',
    pointerEvents: disabled ? 'none' : 'auto',
  };
});

export const Separator = styled(Box)({
  height: '1px',
  backgroundColor: palette.border.default,
  margin: '24px 0',
}) as typeof Box;
